
























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import FormInput from '@/components/FormInput.vue';
import Toggle from '@/components/Toggle.vue';
import Table from '@/components/Table/Table.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';

import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import api from '@/libs/api';
import { User } from '@/libs/api.interfaces';
import { mapState } from 'vuex';
// import { AxiosError } from 'axios';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    FormInput,
    Toggle,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    Button,
    SearchRow,
    SearchField,
    Select,
  },
  data() {
    return {
    };
  },
  methods: {
  },
  computed: mapState(['user']),
})
export default class EditMerchant extends Vue {
  user!: {
    user: User;
  };

  listItemsCC: any = [];
  listItemsBCAKlikPay: {
    tenor: string;
    codePlan: string;
    merchantid: string;
  }[] = [];

  listitemBankCC: {
    id: string;
    bank_id: string;
    channel_id: string;
    type: string;
    tenor: number;
    name: string;
    image_name: string;
  }[] = [];

  listFullpayCC: any = [];

  loadingSubmit = false;
  loadingBank = false;
  loading = false;

  AlfamartOpen = false;
  OvoOpen = false;
  BluOpen = false;
  BncOpen = false;
  BtnOpen = false;
  AtomeOpen = false;
  QrisOpen = false;
  BAGIVAOpen = false;
  ShopeePayOpen = false;
  BNISVAOpen = false;
  IndodanaOpen = false;
  HomeCreditOpen = false;
  KredivoOpen = false;
  DANAOpen = false;
  BayarindWebOpen = false;
  BNIiPayOpen = false;
  EPayBRIOpen = false;
  MaybankVAOpen = false;
  DanamonVAOpen = false;
  BNIVAOpen = false;
  BRIVAOpen = false;
  LinkAjaMeCashOpen = false;
  LinkAjaTCashOpen = false;
  OCTOCLICKSOpen = false;
  MandiriBillPaymentOpen = false;
  CC2002Open = false;
  PermataVAOpen = false;
  BCAVAOpen = false;
  SAKUKUOpen = false;
  KlikBCAOpen = false;
  BCAKlikPayOpen = false;
  SMSOpen = false;
  EmailOpen = false;
  CC2002FullPayOpen = false;
  CC2002InstalimentOpen = false;
  BCAKlikPayIncomOpen = false;
  InComAddOpen = false;
  toggleCBFullPay = '0';
  toggleCBBankChl = 0;

  /* BAGIVA */
  binBAGIVA = '';
  secretKeyBAGIVA = '';
  channelIdBAGIVA = '';

  /* Shopee Pay */
  channelIdShopeePay = '';
  secretKeyShopeePay = '';

  /* Alfamart */
  channelIdAlfamart = '';
  secretKeyAlfamart = '';

  /* Ovo */
  channelIdOvo = '';
  secretKeyOvo = '';

  /* BLU BCA */
  secretKeyBlu = '';
  channelIdBlu = '';

  /* Atome */
  channelIdAtome = '';
  secretKeyAtome = '';

  /* QRIS */
  channelIdQris = '';
  secretKeyQris = '';

  /* BNC */
  binBnc = '';
  channelIdBnc = '';
  secretKeyBnc = '';

  /* BTN */
  binBtn = '';
  channelIdBtn = '';
  secretKeyBtn = '';

  /* BNI Syariah VA */
  binBNISyariahVA = '';
  secretKeyBNISyariahVA = '';
  channelIdBNISyariahVA = '';

  /* Indodana */
  channelIdIndodana = '';
  secretKeyIndodana = '';

  /* Home Credit */
  channelIdHomeCredit = '';
  secretKeyHomeCredit = '';

  /* Kredivo */
  channelIdKredivo = '';
  secretKeyKredivo = '';

  /* DANA */
  channelIdDANA = '';
  secretKeyDANA = '';

  /* Bayarind Web */
  channelIdBayarindWeb = '';
  secretKeyBayarindWeb = '';

  /* BNI i-Pay */
  payeeIdBNIiPay = '';
  secretKeyBNIiPay = '';
  channelIdBNIiPay = '';

  /* e-pay BRI */
  payeeIdEPayBRI = '';
  secretKeyEPayBRI = '';
  channelIdEPayBRI = '';

  /* Maybank VA */
  binMaybankVA = '';
  secretKeyMaybankVA = '';
  channelIdMaybankVA = '';

  /* Danamon VA */
  binDanamonVA = '';
  secretKeyDanamonVA = '';
  channelIdDanamonVA = '';

  /* BNI VA */
  binBNIVA = '';
  secretKeyBNIVA = '';
  channelIdBNIVA = '';

  /* BRI VA */
  binBRIVA = '';
  secretKeyBRIVA = '';
  channelIdBRIVA = '';

  /* LinkAja MeCash */
  channelIdLinkAjaMeCash = '';
  secretKeyLinkAjaMeCash = '';

  /* LinkAja TCash */
  channelIdLinkAjaTCash = '';
  secretKeyLinkAjaTCash = '';

  /* OCTO CLICKS */
  channelIdOCTOCLICKS = '';
  secretKeyOCTOCLICKS = '';

  /* Mandiri Bill Payment */
  channelIdMandiriBillPayment = '';
  bankIDMandiriBillPayment = '';
  companyCodeMandiriBillPayment = '';
  secretKeyMandiriBillPayment = '';

  /* Credit Card 2002 */
  siteIDCC2002 = '';
  profileCodeCC2002 = '';
  secretKeyCC2002 = '';
  creditCardFullPayment = '';
  idFullpayment = '';

  /* Permata VA */
  channelIdPermataVA = '';
  secretKeyPermataVA = '';
  bankIDPermataVA = '';
  bankSubIDPermataVA = '';
  UseEscrowPermataVA: { label: string; value: string } | null = {
    label: 'Escrow Merchant',
    value: '1',
  }

  UseEscrowPermataVAOptions = [
    {
      label: 'Escrow Merchant',
      value: '1',
    },
    {
      label: 'Direct Settlement Merchant',
      value: '2',
    },
  ]

  /* BCA VA */
  companyCodeBCAVA = '';
  subCompanyBCAVA = '';
  secretKeyBCAVA = '';
  channelIdBCAVA = '';

  /* SAKUKU */
  channelIdSAKUKU = '';
  secretKeySAKUKU = '';

  /* KlikBCA */
  klikBCAMerchantCodeKlikBCA = '';
  channelIdKlikBCA = '';
  secretKeyKlikBCA = '';

  /* BCA KlikPay */
  BCAKlikPayCodeKlikBCAKlikPay = '';
  BCAKlikPayClearkeyBCAKlikPay = '';
  BCAKlikPayType: { label: string; value: string } = {
    label: 'Full Payment only',
    value: '01',
  }

  BCAKlikPayTypeOptions: any = [
    {
      label: 'Full Payment only',
      value: '01',
    },
    {
      label: 'Installment',
      value: '02',
    },
    {
      label: 'Combination',
      value: '03',
    },
  ]

  kpInstallmentObj: { options: any[] } = {
    options: [],
  }

  tenor: any = [];
  configCc: any = [];
  disabledInstalment = true;
  BCAKlikPayTenorOptions = [
    {
      label: '3 Bulan',
      value: '03',
    },
    {
      label: '6 Bulan',
      value: '06',
    },
    {
      label: '12 Bulan',
      value: '12',
    },
  ]

  /* SMS */
  smsUsername = '';
  smsPassword = '';
  IPAddress = '';

  /* Email */
  SMTPServer = '';
  SMTPPort = '';
  SMTPUser = '';
  SMTPPassword = '';

  addSite() {
    this.listItemsBCAKlikPay.push({
      tenor: '',
      codePlan: '',
      merchantid: '',
    });
  }

  deleteFormKp(index: any) {
    this.listItemsBCAKlikPay.splice(index, 1);
  }

  deleteChannelBankCC(index: any) {
    this.listitemBankCC.splice(index, 1);
  }

  addChannelBankCC() {
    /* eslint-disable @typescript-eslint/camelcase */
    this.listitemBankCC.push({
      id: '',
      bank_id: '',
      channel_id: '',
      type: 'INSTALLMENT',
      tenor: 0,
      name: '',
      image_name: '',
    });
  }

  changeBankId(key: any) {
    this.banks.forEach((e: any) => {
      if (this.listitemBankCC[key].name === e.name) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        this.listitemBankCC[key].bank_id = e.bank_id;
        // eslint-disable-next-line @typescript-eslint/camelcase
        this.listitemBankCC[key].image_name = e.image_name;
      }
    });
  }

  toggleBAGIOpen() {
    this.BAGIVAOpen = !this.BAGIVAOpen;
  }

  toggleShopeePayOpen() {
    this.ShopeePayOpen = !this.ShopeePayOpen;
  }

  toggleAlfamartOpen() {
    this.AlfamartOpen = !this.AlfamartOpen;
  }

  toggleOvoOpen() {
    this.OvoOpen = !this.OvoOpen;
  }

  toggleBluOpen() {
    this.BluOpen = !this.BluOpen;
  }

  toggleBncOpen() {
    this.BncOpen = !this.BncOpen;
  }

  toggleBtnOpen() {
    this.BtnOpen = !this.BtnOpen;
  }

  toggleAtomeOpen() {
    this.AtomeOpen = !this.AtomeOpen;
  }

  toggleQrisOpen() {
    this.QrisOpen = !this.QrisOpen;
  }

  toggleBNISVAOpen() {
    this.BNISVAOpen = !this.BNISVAOpen;
  }

  toggleIndodanaOpen() {
    this.IndodanaOpen = !this.IndodanaOpen;
  }

  toggleHomeCreditOpen() {
    this.HomeCreditOpen = !this.HomeCreditOpen;
  }

  toggleKredivoOpen() {
    this.KredivoOpen = !this.KredivoOpen;
  }

  toggleDANAOpen() {
    this.DANAOpen = !this.DANAOpen;
  }

  toggleBayarindWebOpen() {
    this.BayarindWebOpen = !this.BayarindWebOpen;
  }

  toggleBNIiPayOpen() {
    this.BNIiPayOpen = !this.BNIiPayOpen;
  }

  toggleEPayBRIOpen() {
    this.EPayBRIOpen = !this.EPayBRIOpen;
  }

  toggleMaybankVAOpen() {
    this.MaybankVAOpen = !this.MaybankVAOpen;
  }

  toggleDanamonVAOpen() {
    this.DanamonVAOpen = !this.DanamonVAOpen;
  }

  toggleBNIVAOpen() {
    this.BNIVAOpen = !this.BNIVAOpen;
  }

  toggleBRIVAOpen() {
    this.BRIVAOpen = !this.BRIVAOpen;
  }

  toggleLinkAjaMeCashOpen() {
    this.LinkAjaMeCashOpen = !this.LinkAjaMeCashOpen;
  }

  toggleLinkAjaTCashOpen() {
    this.LinkAjaTCashOpen = !this.LinkAjaTCashOpen;
  }

  toggleOCTOCLICKSOpen() {
    this.OCTOCLICKSOpen = !this.OCTOCLICKSOpen;
  }

  toggleMandiriBillPaymentOpen() {
    this.MandiriBillPaymentOpen = !this.MandiriBillPaymentOpen;
  }

  toggleCC2002Open() {
    this.CC2002Open = !this.CC2002Open;
  }

  togglePermataVAOpen() {
    this.PermataVAOpen = !this.PermataVAOpen;
  }

  toggleBCAVAOpen() {
    this.BCAVAOpen = !this.BCAVAOpen;
  }

  toggleSAKUKUOpen() {
    this.SAKUKUOpen = !this.SAKUKUOpen;
  }

  toggleKlikBCAOpen() {
    this.KlikBCAOpen = !this.KlikBCAOpen;
  }

  toggleBCAKlikPayOpen() {
    this.BCAKlikPayOpen = !this.BCAKlikPayOpen;
  }

  toggleSMSOpen() {
    this.SMSOpen = !this.SMSOpen;
  }

  toggleEmailOpen() {
    this.EmailOpen = !this.EmailOpen;
  }

  toggleCC2002FullPayOpen() {
    this.CC2002FullPayOpen = !this.CC2002FullPayOpen;
  }

  toggleCC2002InstalimentOpen() {
    this.CC2002InstalimentOpen = !this.CC2002InstalimentOpen;
  }

  selectedBank: { bank_id: string; name: string } | null = null;
  banks = [
    {
      /* eslint-disable @typescript-eslint/camelcase */
      bank_id: '',
      name: 'Enter bank name',
      $isDisabled: true,
      /* eslint-enable @typescript-eslint/camelcase */
    },
  ];

  mounted() {
    this.getConfig();
    this.getBanks();
    this.BCAKlikPayType = this.BCAKlikPayTypeOptions['0'];
  }

  del(id: number) {
    this.listItemsCC.forEach((e: any) => {
      if (id === e.id) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        e.channel_id = '';
      }
    });
  }

  async getInCom() {
    if (this.BCAKlikPayType.value === '02' || this.BCAKlikPayType.value === '03') {
      // this.BCAKlikPayIncomOpen = !this.BCAKlikPayIncomOpen;
      this.BCAKlikPayIncomOpen = true;
    } else {
      this.BCAKlikPayIncomOpen = false;
    }
  }

  async getBanks() {
    try {
      this.loadingBank = true;
      const idData = `${this.$route.params.id}`;
      const { data } = await api.post('/easyinvoice/merchants_config_detail', {
        /* eslint-disable @typescript-eslint/camelcase */
        user_group: '0',
        id: idData,
      });
      this.banks = data.listbank;
      this.loadingBank = false;
    } catch (err) {
      // console.error(err);
    }
  }

  async getConfig() {
    try {
      // console.log(this.user.user);
      this.loading = true;
      const idData = `${this.$route.params.id}`;
      const { data } = await api.post('/easyinvoice/merchants_config_detail', {
        /* eslint-disable @typescript-eslint/camelcase */
        user_group: '0',
        id: idData,
      });
      // this.configStoreData = data.config_store;
      // const cs = data.config_store;
      // const config_name = String;
      // console.log(data.config_store);
      data.config_store.forEach((item: any) => {
        if (item.config_name === '2001_site_id') {
          this.disabledInstalment = false;
        }
        if (item.config_name === '1101_bin') { /* BAGIVA */
          this.binBAGIVA = item.config_values;
        } else if (item.config_name === '1101_secret_key') {
          this.secretKeyBAGIVA = item.config_values;
        } else if (item.config_name === '1101_channel_id') {
          this.channelIdBAGIVA = item.config_values;
        } else if (item.config_name === '1085_channel_id') { /* Shopee Pay */
          this.channelIdShopeePay = item.config_values;
        } else if (item.config_name === '1085_secret_key') {
          this.secretKeyShopeePay = item.config_values;
        } else if (item.config_name === '1087_channel_id') { /* Alfamart */
          this.channelIdAlfamart = item.config_values;
        } else if (item.config_name === '1087_secret_key') {
          this.secretKeyAlfamart = item.config_values;
        } else if (item.config_name === '1086_channel_id') { /* Ovo */
          this.channelIdOvo = item.config_values;
        } else if (item.config_name === '1086_secret_key') {
          this.secretKeyOvo = item.config_values;
        } else if (item.config_name === '1026_channel_id') { /* Blu BCA */
          this.channelIdBlu = item.config_values;
        } else if (item.config_name === '1026_secret_key') {
          this.secretKeyBlu = item.config_values;
        } else if (item.config_name === '1088_channel_id') { /* Atome */
          this.channelIdAtome = item.config_values;
        } else if (item.config_name === '1088_secret_key') {
          this.secretKeyAtome = item.config_values;
        } else if (item.config_name === '1089_channel_id') { /* QRIS */
          this.channelIdQris = item.config_values;
        } else if (item.config_name === '1089_secret_key') {
          this.secretKeyQris = item.config_values;
        } else if (item.config_name === '1090_channel_id') { /* BNC VA */
          this.channelIdBnc = item.config_values;
        } else if (item.config_name === '1090_secret_key') {
          this.secretKeyBnc = item.config_values;
        } else if (item.config_name === '1090_bin') {
          this.binBnc = item.config_values;
        } else if (item.config_name === '1092_channel_id') { /* BTN VA */
          this.channelIdBtn = item.config_values;
        } else if (item.config_name === '1092_secret_key') {
          this.secretKeyBtn = item.config_values;
        } else if (item.config_name === '1092_bin') {
          this.binBtn = item.config_values;
        } else if (item.config_name === '1043_bin') { /* BNI Syariah VA */
          this.binBNISyariahVA = item.config_values;
        } else if (item.config_name === '1043_secret_key') {
          this.secretKeyBNISyariahVA = item.config_values;
        } else if (item.config_name === '1043_channel_id') {
          this.channelIdBNISyariahVA = item.config_values;
        } else if (item.config_name === '1080_channel_id') { /* Indodana */
          this.channelIdIndodana = item.config_values;
        } else if (item.config_name === '1080_secret_key') {
          this.secretKeyIndodana = item.config_values;
        } else if (item.config_name === '1078_channel_id') { /* Home Credit */
          this.channelIdHomeCredit = item.config_values;
        } else if (item.config_name === '1078_secret_key') {
          this.secretKeyHomeCredit = item.config_values;
        } else if (item.config_name === '1073_channel_id') { /* Kredivo */
          this.channelIdKredivo = item.config_values;
        } else if (item.config_name === '1073_secret_key') {
          this.secretKeyKredivo = item.config_values;
        } else if (item.config_name === '1084_channel_id') { /* DANA */
          this.channelIdDANA = item.config_values;
        } else if (item.config_name === '1084_secret_key') {
          this.secretKeyDANA = item.config_values;
        } else if (item.config_name === '1083_channel_id') { /* Bayarind Web */
          this.channelIdBayarindWeb = item.config_values;
        } else if (item.config_name === '1083_secret_key') {
          this.secretKeyBayarindWeb = item.config_values;
        } else if (item.config_name === '1041_payee_id') { /* BNI i-Pay */
          this.payeeIdBNIiPay = item.config_values;
        } else if (item.config_name === '1041_secret_key') {
          this.secretKeyBNIiPay = item.config_values;
        } else if (item.config_name === '1041_channel_id') {
          this.channelIdBNIiPay = item.config_values;
        } else if (item.config_name === '1061_payeeid') { /* e-pay BRI */
          this.payeeIdEPayBRI = item.config_values;
        } else if (item.config_name === '1061_secret_key') {
          this.secretKeyEPayBRI = item.config_values;
        } else if (item.config_name === '1061_channel_id') {
          this.channelIdEPayBRI = item.config_values;
        } else if (item.config_name === '1052_bin') { /* Maybank VA */
          this.binMaybankVA = item.config_values;
        } else if (item.config_name === '1052_secret_key') {
          this.secretKeyMaybankVA = item.config_values;
        } else if (item.config_name === '1052_channel_id') {
          this.channelIdMaybankVA = item.config_values;
        } else if (item.config_name === '1074_bin') { /* Danamon VA */
          this.binDanamonVA = item.config_values;
        } else if (item.config_name === '1074_secret_key') {
          this.secretKeyDanamonVA = item.config_values;
        } else if (item.config_name === '1074_channel_id') {
          this.channelIdDanamonVA = item.config_values;
        } else if (item.config_name === '1042_bin') { /* BNI VA */
          this.binBNIVA = item.config_values;
        } else if (item.config_name === '1042_secret_key') {
          this.secretKeyBNIVA = item.config_values;
        } else if (item.config_name === '1042_channel_id') {
          this.channelIdBNIVA = item.config_values;
        } else if (item.config_name === '1062_bin') { /* BRI VA */
          this.binBRIVA = item.config_values;
        } else if (item.config_name === '1062_secret_key') {
          this.secretKeyBRIVA = item.config_values;
        } else if (item.config_name === '1062_channel_id') {
          this.channelIdBRIVA = item.config_values;
        } else if (item.config_name === '1031_channel_id') { /* LinkAja MeCash */
          this.channelIdLinkAjaMeCash = item.config_values;
        } else if (item.config_name === '1031_secret_key') {
          this.secretKeyLinkAjaMeCash = item.config_values;
        } else if (item.config_name === '1077_channel_id') { /* LinkAja TCash */
          this.channelIdLinkAjaTCash = item.config_values;
        } else if (item.config_name === '1077_secret_key') {
          this.secretKeyLinkAjaTCash = item.config_values;
        } else if (item.config_name === '1081_channel_id') { /* OCTO CLICKS */
          this.channelIdOCTOCLICKS = item.config_values;
        } else if (item.config_name === '1081_secret_key') {
          this.secretKeyOCTOCLICKS = item.config_values;
        } else if (item.config_name === '1032_channel_id') { /* Mandiri Bill Payment */
          this.channelIdMandiriBillPayment = item.config_values;
        } else if (item.config_name === '1032_bank_id') {
          this.bankIDMandiriBillPayment = item.config_values;
        } else if (item.config_name === '1032_company_code') {
          this.companyCodeMandiriBillPayment = item.config_values;
        } else if (item.config_name === '1032_secret_key') {
          this.secretKeyMandiriBillPayment = item.config_values;
        } else if (item.config_name === '2001_site_id') { /* Credit Card 2002 */
          this.siteIDCC2002 = item.config_values;
        } else if (item.config_name === '2001_profile_code') {
          this.profileCodeCC2002 = item.config_values;
        } else if (item.config_name === '2001_secret_key') {
          this.secretKeyCC2002 = item.config_values;
        } else if (item.config_name === '2001_channel_ids') {
          this.toggleCBFullPay = '1';
          this.CC2002FullPayOpen = true;
          this.creditCardFullPayment = item.config_cc.bank_0[0].channel_id;
          this.idFullpayment = item.config_cc.bank_0[0].id;
          const configCC = JSON.parse(JSON.stringify(item.config_cc));
          const configCCInstalment = [];
          const configCCFullPayment = [];
          /* eslint-disable */
          for (let CCFilter in configCC) {
            if (CCFilter !== 'bank_0') {
              configCCInstalment.push(configCC[CCFilter]);
            } else {
              configCCFullPayment.push(configCC[CCFilter]);
            }
          }
          /* eslint-enable */
          configCCInstalment.forEach((value: any) => {
            value.forEach((e: any) => {
              this.listitemBankCC.push(e);
              this.CC2002InstalimentOpen = true;
              this.toggleCBBankChl = 1;
            });
          });
          // configCCFullPayment.forEach((value: any) => {
          //   value.forEach((e: any) => {
          //     this.listFullpayCC.push(e);
          //     this.CC2002FullPayOpen = true;
          //   });
          // });
        } else if (item.config_name === 'pva_channel_id') { /* Permata VA */
          this.channelIdPermataVA = item.config_values;
        } else if (item.config_name === 'pva_secret_key') {
          this.secretKeyPermataVA = item.config_values;
        } else if (item.config_name === 'pva_bank_id') {
          this.bankIDPermataVA = item.config_values;
        } else if (item.config_name === 'pva_sub_id') {
          this.bankSubIDPermataVA = item.config_values;
        } else if (item.config_name === 'pva_use_escrow') {
          this.UseEscrowPermataVA = this.UseEscrowPermataVAOptions.find((e) => e.value === item.config_values) || null;
        } else if (item.config_name === 'company_code') { /* BCA VA */
          this.companyCodeBCAVA = item.config_values;
        } else if (item.config_name === '1021_sub_company') {
          this.subCompanyBCAVA = item.config_values;
        } else if (item.config_name === 'secret_key') {
          this.secretKeyBCAVA = item.config_values;
        } else if (item.config_name === '1021_channel_id') {
          this.channelIdBCAVA = item.config_values;
        } else if (item.config_name === '1024_channel_id') { /* SAKUKU */
          this.channelIdSAKUKU = item.config_values;
        } else if (item.config_name === '1024_secret_key') {
          this.secretKeySAKUKU = item.config_values;
        } else if (item.config_name === 'kb_merchant_code') { /* KlikBCA */
          // console.log(item.config_values);
          this.klikBCAMerchantCodeKlikBCA = item.config_values;
        } else if (item.config_name === 'kb_channel_id') {
          this.channelIdKlikBCA = item.config_values;
        } else if (item.config_name === 'kb_secret_key') {
          this.secretKeyKlikBCA = item.config_values;
        } else if (item.config_name === 'kp_klikpaycode') { /* BCA KlikPay */
          this.BCAKlikPayCodeKlikBCAKlikPay = item.config_values;
        } else if (item.config_name === 'kp_clearkey') {
          this.BCAKlikPayClearkeyBCAKlikPay = item.config_values;
        } else if (item.config_name === 'kp_type') {
          if (item.config_values === '01') {
            this.BCAKlikPayType = this.BCAKlikPayTypeOptions['0'];
          } else if (item.config_values === '02') {
            this.BCAKlikPayType = this.BCAKlikPayTypeOptions['1'];
            this.BCAKlikPayIncomOpen = true;
          } else if (item.config_values === '03') {
            this.BCAKlikPayType = this.BCAKlikPayTypeOptions['2'];
            this.BCAKlikPayIncomOpen = true;
          }
        } else if (item.config_name === 'kp_installment') {
          const kpInst = JSON.parse(item.config_values);
          this.listItemsBCAKlikPay = kpInst.options;
        } else if (item.config_name === 'sms_username') { /* SMS */
          this.smsUsername = item.config_values;
        } else if (item.config_name === 'sms_passwd') {
          this.smsPassword = item.config_values;
        } else if (item.config_name === 'ip_address') {
          this.IPAddress = item.config_values;
        } else if (item.config_name === 'smtp_server') { /* Email */
          this.SMTPServer = item.config_values;
        } else if (item.config_name === 'smtp_port') {
          this.SMTPPort = item.config_values;
        } else if (item.config_name === 'smtp_user') {
          this.SMTPUser = item.config_values;
        } else if (item.config_name === 'smtp_passwd') {
          this.SMTPPassword = item.config_values;
        }
      });
      this.loading = false;
    } catch (err) {
      this.loading = false;
    }
  }

  async save() {
    try {
      this.loadingSubmit = true;
      const idData = `${this.$route.params.id}`;

      /* eslint-disable */


      const BCAKPType = this.BCAKlikPayType === null ? undefined : this.BCAKlikPayType.value
      // console.log('BCAKPType', BCAKPType);
      // if (BCAKPType !== undefined) {
      if (BCAKPType === '01') {
        this.kpInstallmentObj.options.push();
      } else {
        for (var i = 0; i < this.listItemsBCAKlikPay.length; i++) {
          this.kpInstallmentObj.options.push(this.listItemsBCAKlikPay[i]);
        }
      }
      // }
      const kpInstallmentData = JSON.stringify(this.kpInstallmentObj);

      this.configCc = [];
      var filtered_array = [];
      for (var i = 0; i < this.listitemBankCC.length; i++) {
        if (filtered_array.indexOf(this.listitemBankCC[i].bank_id) === -1) {
          filtered_array.push(this.listitemBankCC[i].bank_id);
        }
      }

      filtered_array.forEach((e: any) => {
        var channel: any = [];
        this.listitemBankCC.forEach((x: any) => {
          if (e === x.bank_id) {
            channel.push(x)
          }
        });
        this.configCc.push({
          bankId: e,
          channel: channel,
        });
      });

      const form = new FormData();
      this.configCc.forEach((e: any, k: any) => {
        const idxCid = k;
        form.append('bank[' + k + '][bank_id]', e.bankId.toString());
        e.channel.forEach((x: any, y: any) => {
          // form.append('bank['+ k +'][channel][' + y +'][id]', x.id.toString());
          form.append('bank[' + k + '][channel][' + y + '][id]', idxCid.toString());
          form.append('bank[' + k + '][channel][' + y + '][channel_id]', x.channel_id.toString());
          form.append('bank[' + k + '][channel][' + y + '][tenor]', x.tenor.toString());
        })
      })

      const arr: any = {};
      // const idFullpayment = '';
      // if (this.toggleCBBankChl === 0) {
      //   const idFp = '1';
      //   idFullpayment.concat(idFp);
      // } else if () {
      // }

      form.append('user_group', '0');
      form.append('id', idData);
      form.append('merchant_id', idData);
      //BAGIVA
      form.append('1101_bin', this.binBAGIVA);
      form.append('1101_channel_id', this.channelIdBAGIVA);
      form.append('1101_secret_key', this.secretKeyBAGIVA);
      //Shopee Pay
      form.append('1085_channel_id', this.channelIdShopeePay);
      form.append('1085_secret_key', this.secretKeyShopeePay);
      //Alfamart
      form.append('1087_channel_id', this.channelIdAlfamart);
      form.append('1087_secret_key', this.secretKeyAlfamart);
      //Ovo
      form.append('1086_channel_id', this.channelIdOvo);
      form.append('1086_secret_key', this.secretKeyOvo);
      //Blu BCA
      form.append('1026_channel_id', this.channelIdBlu);
      form.append('1026_secret_key', this.secretKeyBlu);
      //Atome
      form.append('1088_channel_id', this.channelIdAtome);
      form.append('1088_secret_key', this.secretKeyAtome);
      //QRIS
      form.append('1089_channel_id', this.channelIdQris);
      form.append('1089_secret_key', this.secretKeyQris);
      //BNC VA
      form.append('1090_bin', this.binBnc);
      form.append('1090_secret_key', this.secretKeyBnc);
      form.append('1090_channel_id', this.channelIdBnc);
      //BTN VA
      form.append('1092_bin', this.binBtn);
      form.append('1092_secret_key', this.secretKeyBtn);
      form.append('1092_channel_id', this.channelIdBtn);
      //BNI Syariah VA
      form.append('1043_bin', this.binBNISyariahVA);
      form.append('1043_secret_key', this.secretKeyBNISyariahVA);
      form.append('1043_channel_id', this.channelIdBNISyariahVA);
      //Indodana
      form.append('1080_channel_id', this.channelIdIndodana);
      form.append('1080_secret_key', this.secretKeyIndodana);
      //Home Credit
      form.append('1078_channel_id', this.channelIdHomeCredit);
      form.append('1078_secret_key', this.secretKeyHomeCredit);
      //Kredivo
      form.append('1073_channel_id', this.channelIdKredivo);
      form.append('1073_secret_key', this.secretKeyKredivo);
      //DANA
      form.append('1084_channel_id', this.channelIdDANA);
      form.append('1084_secret_key', this.secretKeyDANA);
      //Bayarind Web
      form.append('1083_channel_id', this.channelIdBayarindWeb);
      form.append('1083_secret_key', this.secretKeyBayarindWeb);
      //BNI i-Pay
      form.append('1041_payee_id', this.payeeIdBNIiPay);
      form.append('1041_secret_key', this.secretKeyBNIiPay);
      form.append('1041_channel_id', this.channelIdBNIiPay);
      //e-pay BRI
      form.append('1061_payeeid', this.payeeIdEPayBRI);
      form.append('1061_secret_key', this.secretKeyEPayBRI);
      form.append('1061_channel_id', this.channelIdEPayBRI);
      //Maybank VA
      form.append('1052_bin', this.binMaybankVA);
      form.append('1052_secret_key', this.secretKeyMaybankVA);
      form.append('1052_channel_id', this.channelIdMaybankVA);
      //Danamon VA
      form.append('1074_bin', this.binDanamonVA);
      form.append('1074_secret_key', this.secretKeyDanamonVA);
      form.append('1074_channel_id', this.channelIdDanamonVA);
      //BNI VA
      form.append('1042_bin', this.binBNIVA);
      form.append('1042_secret_key', this.secretKeyBNIVA);
      form.append('1042_channel_id', this.channelIdBNIVA);
      //BRI VA
      form.append('1062_bin', this.binBRIVA);
      form.append('1062_secret_key', this.secretKeyBRIVA);
      form.append('1062_channel_id', this.channelIdBRIVA);
      //LinkAja MeCash
      form.append('1031_channel_id', this.channelIdLinkAjaMeCash);
      form.append('1031_secret_key', this.secretKeyLinkAjaMeCash);
      //LinkAja TCash
      form.append('1077_channel_id', this.channelIdLinkAjaTCash);
      form.append('1077_secret_key', this.secretKeyLinkAjaTCash);
      //OCTO CLICKS
      form.append('1081_channel_id', this.channelIdOCTOCLICKS);
      form.append('1081_secret_key', this.secretKeyOCTOCLICKS);
      //Mandiri Bill Payment
      form.append('1032_channel_id', this.channelIdMandiriBillPayment);
      form.append('1032_bank_id', this.bankIDMandiriBillPayment);
      form.append('1032_company_code', this.companyCodeMandiriBillPayment);
      form.append('1032_secret_key', this.secretKeyMandiriBillPayment);
      //Credit Card 2002
      form.append('2001_site_id', this.siteIDCC2002);
      form.append('2001_profile_code', this.profileCodeCC2002);
      form.append('2001_secret_key', this.secretKeyCC2002);
      form.append('channel_fullpayment', this.creditCardFullPayment);
      // form.append('2001_channel_ids', JSON.stringify(arr));
      form.append('is_fullpayment', this.toggleCBFullPay);
      if (this.toggleCBBankChl === 0) {
        form.append('id_fullpayment', '0');
      } else {
        form.append('id_fullpayment', this.idFullpayment);
        form.append('is_installment', '1');
      }
      //Permata VA
      form.append('pva_channel_id', this.channelIdPermataVA);
      form.append('pva_secret_key', this.secretKeyPermataVA);
      form.append('pva_bank_id', this.bankIDPermataVA);
      form.append('pva_sub_id', this.bankSubIDPermataVA);
      form.append('pva_use_escrow', this.UseEscrowPermataVA?.value || '');
      //BCA VA
      form.append('company_code', this.companyCodeBCAVA);
      form.append('1021_sub_company', this.subCompanyBCAVA);
      form.append('secret_key', this.secretKeyBCAVA);
      form.append('1021_channel_id', this.channelIdBCAVA);
      //SAKUKU
      form.append('1024_channel_id', this.channelIdSAKUKU);
      form.append('1024_secret_key', this.secretKeySAKUKU);
      //KlikBCA
      form.append('kb_merchant_code', this.klikBCAMerchantCodeKlikBCA);
      form.append('kb_channel_id', this.channelIdKlikBCA);
      form.append('kb_secret_key', this.secretKeyKlikBCA);
      //BCA KlikPay
      form.append('kp_klikpaycode', this.BCAKlikPayCodeKlikBCAKlikPay);
      form.append('kp_clearkey', this.BCAKlikPayClearkeyBCAKlikPay);
      form.append('kp_type', this.BCAKlikPayType?.value);
      // if (BCAKPType !== 'undefined') {
      form.append('kp_installment', kpInstallmentData);
      // }
      //SMS
      form.append('sms_username', this.smsUsername);
      form.append('sms_passwd', this.smsPassword);
      form.append('ip_address', this.IPAddress);
      //Email
      form.append('smtp_server', this.SMTPServer);
      form.append('smtp_port', this.SMTPPort);
      form.append('smtp_user', this.SMTPUser);
      form.append('smtp_passwd', this.SMTPPassword);

      const { data } = await api.post('easyinvoice/merchants_config_save', form);

      // console.log('ini', data);
      // const { data } = await api.post('easyinvoice/merchants_config_save', {
      /* eslint-disable @typescript-eslint/camelcase */
      // user_group: '0',
      // id: idData,
      // merchant_id: idData,
      //   /* BAGIVA */
      //   '1101_bin': this.binBAGIVA,
      //   '1101_channel_id': this.secretKeyBAGIVA,
      //   '1101_secret_key': this.channelIdBAGIVA,
      //   /* Shopee Pay */
      //   '1085_channel_id': this.channelIdShopeePay,
      //   '1085_secret_key': this.secretKeyShopeePay,
      //   /* BNI Syariah VA */
      //   '1043_bin': this.binBNISyariahVA,
      //   '1043_secret_key': this.secretKeyBNISyariahVA,
      //   '1043_channel_id': this.channelIdBNISyariahVA,
      //   /* Indodana */
      //   '1080_channel_id': this.channelIdIndodana,
      //   '1080_secret_key': this.secretKeyIndodana,
      //   /* Home Credit */
      //   '1078_channel_id': this.channelIdHomeCredit,
      //   '1078_secret_key': this.secretKeyHomeCredit,
      //   /* Kredivo */
      //   '1073_channel_id': this.channelIdKredivo,
      //   '1073_secret_key': this.secretKeyKredivo,
      //   /* DANA */
      //   '1084_channel_id': this.channelIdDANA,
      //   '1084_secret_key': this.secretKeyDANA,
      //   /* Bayarind Web */
      //   '1083_channel_id': this.channelIdBayarindWeb,
      //   '1083_secret_key': this.secretKeyBayarindWeb,
      //   /* BNI i-Pay */
      //   '1041_payee_id': this.payeeIdBNIiPay,
      //   '1041_secret_key': this.secretKeyBNIiPay,
      //   '1041_channel_id': this.channelIdBNIiPay,
      //   /* e-pay BRI */
      //   '1061_payeeid': this.payeeIdEPayBRI,
      //   '1061_secret_key': this.secretKeyEPayBRI,
      //   '1061_channel_id': this.channelIdEPayBRI,
      //   /* Maybank VA */
      //   '1052_bin': this.binMaybankVA,
      //   '1052_secret_key': this.secretKeyMaybankVA,
      //   '1052_channel_id': this.channelIdMaybankVA,
      //   /* Danamon VA */
      //   '1074_bin': this.binDanamonVA,
      //   '1074_secret_key': this.secretKeyDanamonVA,
      //   '1074_channel_id': this.channelIdDanamonVA,
      //   /* BNI VA */
      //   '1042_bin': this.binBNIVA,
      //   '1042_secret_key': this.secretKeyBNIVA,
      //   '1042_channel_id': this.channelIdBNIVA,
      //   /* BRI VA */
      //   '1062_bin': this.binBRIVA,
      //   '1062_secret_key': this.secretKeyBRIVA,
      //   '1062_channel_id': this.channelIdBRIVA,
      //   /* LinkAja MeCash */
      //   '1031_channel_id': this.channelIdLinkAjaMeCash,
      //   '1031_secret_key': this.secretKeyLinkAjaMeCash,
      //   /* LinkAja TCash */
      //   '1077_channel_id': this.channelIdLinkAjaTCash,
      //   '1077_secret_key': this.secretKeyLinkAjaTCash,
      //   /* OCTO CLICKS */
      //   '1081_channel_id': this.channelIdOCTOCLICKS,
      //   '1081_secret_key': this.secretKeyOCTOCLICKS,
      //   /* Mandiri Bill Payment */
      //   '1032_channel_id': this.channelIdMandiriBillPayment,
      //   '1032_bank_id': this.bankIDMandiriBillPayment,
      //   '1032_company_code': this.companyCodeMandiriBillPayment,
      //   '1032_secret_key': this.secretKeyMandiriBillPayment,
      // /* Credit Card 2002 */
      // '2001_site_id': this.siteIDCC2002,
      // '2001_profile_code': this.profileCodeCC2002,
      // '2001_secret_key': this.secretKeyCC2002,
      // '2001_channel_ids': bankPush,
      //   /* Permata VA */
      //   pva_channel_id: this.channelIdPermataVA,
      //   pva_secret_key: this.secretKeyPermataVA,
      //   pva_bank_id: this.bankIDPermataVA,
      //   pva_sub_id: this.bankSubIDPermataVA,
      //   pva_use_escrow: this.UseEscrowPermataVA.value,
      //   /* BCA VA */
      //   company_code: this.companyCodeBCAVA,
      //   '1021_sub_company': this.subCompanyBCAVA,
      //   secret_key: this.secretKeyBCAVA,
      //   '1021_channel_id': this.channelIdBCAVA,
      //   /* SAKUKU */
      //   '1024_channel_id': this.channelIdSAKUKU,
      //   '1024_secret_key': this.secretKeySAKUKU,
      //   /* KlikBCA */
      //   kb_merchant_code: this.klikBCAMerchantCodeKlikBCA,
      //   kb_channel_id: this.channelIdKlikBCA,
      //   kb_secret_key: this.secretKeyKlikBCA,
      //   /* BCA KlikPay */
      //   kp_klikpaycode: this.BCAKlikPayCodeKlikBCAKlikPay,
      //   kp_clearkey: this.BCAKlikPayClearkeyBCAKlikPay,
      //   kp_type: this.BCAKlikPayType.value,
      //   kp_installment: kpInstallmentData,
      //   /* SMS */
      //   sms_username: this.smsUsername,
      //   sms_passwd: this.smsPassword,
      //   ip_address: this.IPAddress,
      //   /* Email */
      //   smtp_server: this.SMTPServer,
      //   smtp_port: this.SMTPPort,
      //   smtp_user: this.SMTPUser,
      //   smtp_passwd: this.SMTPPassword,
      // });
      // console.log(data);
      if (data.status === '00') {
        this.loadingSubmit = false;
        showToast(ToastType.SUCCESS, 'Merchant Config Success', data.message);
        // this.$router.push('/easyinvoice/configuration/merchant');
      } else if (data.status === '01') {
        this.loadingSubmit = false;
        data.error[0].forEach((err: any) => {
          // console.log(err);
          showToast(ToastType.FAILED, data.message, err);
        });
      }
      this.loadingSubmit = false;
    } catch (err) {
      console.log(err);
      this.loadingSubmit = false;
    }
  }
}
